// extracted by mini-css-extract-plugin
module.exports = {"box":"_3FrN1","store":"DqkVk","selectCon":"_1d5Uh","searchIcon":"_1AooA"};